import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { MdAdd } from "react-icons/md";
import { BsInfoCircleFill } from "react-icons/bs";
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { TbArrowsSort } from "react-icons/tb";
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { FaCopy } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaDownload } from "react-icons/fa"; // <-- Download icon

import Addgroup from './addgroup';
import image from '../images/templatelibrary.png'
import axios from 'axios'; // <-- Add axios for api calls

// API endpoint for uploading media (Assuming this matches your @authRoutes.ts POST route)
const UPLOAD_MEDIA_API = `${process.env.REACT_APP_API_BASE}/auth//media/upload`; // Change to correct route from your backend if needed
const API_URL = process.env.REACT_APP_API_BASE || "https://wa-api.globebot.io";
const MEDIA_FETCH_API = `${API_URL}/auth/media/wabaId`; // guess based on pattern - adapt route as per backend

function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        );
        return JSON.parse(jsonPayload);
    } catch { return {}; }
}

function getUserIdFromToken() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
    }
    return { userId: null, token: null };
}

function MediaLibrary() {
    const [open, setopen] = useState(false);
    const [Channel, setChannel] = useState('');
    const [showfilter, setshowfilter] = useState(false);
    const [MediaName, setMediaName] = useState('');
    const [addgroupname, setaddgroupname] = useState('');
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    // Multi-upload: store FileList or Array<File>
    const [mediaFiles, setMediaFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [wabaid, setWabaId] = useState([]);
    const { userId, token } = getUserIdFromToken();
    const [userdata, setUserData] = useState([]);

    // Fetch WABA Ids
    useEffect(() => {
        if (!userId) {
            setWabaId([]);
            return;
        }
        axios
            .get(`${API_URL}/auth/whatsapp/waba_ids?user_id=${userId}`)
            .then((res) => {
                const wabas = Array.isArray(res.data?.waba_ids) ? res.data.waba_ids : [];
                setWabaId(wabas);
            })
            .catch(() => setWabaId([]));
    }, [userId]);

    // Fetch User Data
    useEffect(() => {
        if (!userId) {
            setUserData([]);
            return;
        }
        axios
            .get(`${API_URL}/auth/user/${userId}`)
            .then((res) => {
                // Assume response is a user object, not array, so put in array for setUserData
                const user = res.data && typeof res.data === 'object' && !Array.isArray(res.data) ? res.data : {};
                setUserData([user.user]);
                console.log("userdata ", user)
            })
            .catch(() => setUserData([]));
    }, [userId]);

    // Fetch Media from API
    useEffect(() => {
        if (!userId) return;
        setErrorMsg('');
        axios
            .get(`${API_URL}/auth/media/wabaId/${wabaid[0]}`)
            .then((res) => {
                // API returns: { data: [ { img: <path> }, ... ] }
                let mediaArr = Array.isArray(res.data?.data) ? res.data.data : [];
                // Extract filename from img path, and use it for both Url and image display
                const media = mediaArr.map((m, idx) => {
                    // fallback for missing img property
                    let imgPath = m.img || "";
                    // Remove the unwanted server path if present
                    const unwantedPrefix = "/home/anbums/public_html/globewaapi";
                    if (imgPath.startsWith(unwantedPrefix)) {
                        imgPath = imgPath.replace(unwantedPrefix, "");
                    }
                    // Prepend API_URL if not already absolute
                    let displayImgPath = imgPath;
                    if (imgPath && !/^https?:\/\//.test(imgPath)) {
                        // remove double slashes before joining if needed
                        displayImgPath = (process.env.REACT_APP_API_BASE || "") + (imgPath.startsWith("/") ? imgPath : "/" + imgPath);
                    }
                    // Try to find a filename for display, fallback to the whole path if needed
                    const urlParts = imgPath.split('/');
                    const fileName = urlParts.length > 0 ? urlParts[urlParts.length - 1] : imgPath;
                    return {
                        id: idx + 1,
                        imageid: m.id, // since backend doesn't provide id, use array index 1-based
                        image: displayImgPath, // now uses public API_URL if local path
                        Url: displayImgPath,   // show full public URL
                        fileName,              // add filename for download attribute
                    };
   
                });
                setData(media);
                setFilteredData(media);
            })
            .catch((e) => {
                setErrorMsg('Failed to fetch media');
                setData([]);
                setFilteredData([]);
            });
    }, [userId, open, successMsg, wabaid]);

    // Filtering logic
    useEffect(() => {
        if (!MediaName) {
            setFilteredData(data);
            return;
        }
        setFilteredData(
            data.filter(d => (d.Url || '').toLowerCase().includes(MediaName.toLowerCase()))
        );
    }, [MediaName, data]);

    function getdata() {
        // Filtering is now handled reactively via above useEffect; could manually setFilteredData, but not needed.
    }

    // console.log("wabaid ", wabaid[0])

    function clearFilter() {
        setMediaName('');
        setFilteredData(data);
    }

    // ---- Updated upload handler: Multi-file, fields: name, wabaId ----
    async function handleAddMedia(e) {
        e.preventDefault();
        setErrorMsg('');
        setSuccessMsg('');
        if (!Channel) {
            setErrorMsg('Please select a WhatsApp Business Account (Channel).');
            return;
        }
        if (!mediaFiles || mediaFiles.length === 0) {
            setErrorMsg('Please select one or more media files.');
            return;
        }
        // MediaName used for folder/name (API field "name"), fallback to group/addgroupname or "Untitled"
        const nameValue = MediaName || addgroupname || 'Untitled';

        if (!nameValue) {
            setErrorMsg("Please enter a Media Name.");
            return;
        }
        setUploading(true);
        try {
            const formData = new FormData();
            formData.append("name", nameValue);
            formData.append("wabaId", Channel);

            // For multi-upload, mediaFiles is array of File
            for (let file of mediaFiles) {
                formData.append("file", file); // field name for multer.array("file")
            }

            // No need to set Content-Type, axios will inject for multipart
            const res = await axios.post(
                `${UPLOAD_MEDIA_API}?name=${userdata[0]?.name || ''}&wabaId=${Channel}`,
                formData
            );

            if (res.status === 200 && res.data.success) {
                setSuccessMsg('Media uploaded successfully!');
                setopen(false);
                // New media fetched via useEffect
            } else {
                setErrorMsg(res.data?.error || res.data?.message || 'Failed to upload media.');
            }
        } catch (err) {
            setErrorMsg(
                err?.response?.data?.error ||
                err?.response?.data?.message ||
                err?.message ||
                'Failed to upload media.'
            );
        } finally {
            setUploading(false);
            setMediaFiles([]);
            setChannel('');
        }
    }

    // Optional: copy & delete actions for each media item
    async function handleDeleteMedia(id) {
        if (!window.confirm('Are you sure you want to delete this media?')) return;
        setErrorMsg('');
        try {
            const DEL_URL = `${API_URL}/auth/media/${id}`; // adjust route as per backend!
            await axios.delete(DEL_URL);
            setSuccessMsg('Media deleted successfully.');
            // Triggers refetch via successMsg change
        } catch (err) {
            setErrorMsg('Failed to delete media');
        }
    }

    function handleCopy(url) {
        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(url);
            setSuccessMsg('Copied to clipboard');
            setTimeout(() => setSuccessMsg(''), 1000);
        }
    }

    // Download handler - pure browser way
    function handleDownload(url, filename = "") {
        // fallback to random filename if not provided
        const fallbackName = "media_file";
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename || fallbackName);
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setSuccessMsg('Download started');
        setTimeout(() => setSuccessMsg(''), 1000);
    }

    return (
        <>
            <div className='px-2 dark:bg-[#121519] h-[100vh] pl-4 pr-4'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 w-[100%] flex justify-between items-center '>
                    <div>
                        <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff] flex items-center'>  <Link to='/configuration'><FaArrowLeftLong /> </Link>    Media Library</h1>
                        <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  <span>WhatsApp</span> <IoIosArrowForward /><span>Media Library</span>
                        </div>
                    </div>
                    <div className='pr-4'>
                        <button
                            onClick={() => setopen(true)}
                            className='bg-[#37715de7] text-[#fff]  text-[13px] flex items-center py-2    px-4 rounded-md font-semibold gap-1'>
                            <MdAdd className='text-[#fff] text-[16px] font-bold' />
                            Add Media
                        </button>
                    </div>
                </div>
                <div className='bg-[#ecf2fa] border-[1px] border-[#d9e5f4] p-2 rounded-md mt-4 flex gap-1 '>
                    <BsInfoCircleFill className='text-[#2e66a8] mt-1' />
                    <p className='text-[#2e66a8] text-[16px] '>  As per Meta (WhatsApp) media retention policies, only media files from the last 30 days are available in the Media Library. Older media is automatically deleted. If required, please re-upload the media.</p>
                </div>
                <div onClick={() => setshowfilter(!showfilter)}
                    className='w-[100%] flex justify-between  px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4'>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        <RiCollapseDiagonalLine />
                        Filter Records
                    </div>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                    </div>
                </div>
                {showfilter &&
                    <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519]'>
                        <div className='w-[100%] flex flex-wrap gap-4'>
                            <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Media Name:</label>
                                <input
                                    value={MediaName}
                                    onChange={(e) => setMediaName(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                    placeholder='Enter Image Name'
                                />
                            </div>
                            <div className='w-full sm:w-[48%] lg:w-[24%] flex items-center gap-1 mt-4'>
                                <button
                                    onClick={() => getdata()} // filtering is now handled reactively!
                                    className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'
                                >
                                    <FaFilter /> <span className='text-[12px] font-bold'>Filter</span>
                                </button>

                                <button
                                    onClick={() => clearFilter()}
                                    className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                                >
                                    <TbReload /> <span className='text-[12px] font-bold'>Clear Filter</span>
                                </button>
                            </div>
                        </div>
                    </div>
                }
                <table className="w-full   overflow-hidden border-[1px] border-[#dee2e6] ">
                    <thead>
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Media</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>URL</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2  cursor-pointer border-[1px] border-[#dee2e6] ">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Actions</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length > 0 ? (
                            filteredData.map((item) => (
                                <tr
                                    key={item.id}
                                    className=" text-gray-500 odd:bg-white even:bg-[#edf1f5] 
        dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#edf1f5]"
                                >
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">
                                        <img src={item.image} alt="" className='w-14 object-cover' />
                                    </td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">
                                        {item.Url}
                                    </td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] dark:text-[#fff] ">
                                        <div className='flex items-center gap-2'>
                                            <div
                                                className='border-[#37715d] border-[1px] p-1 hover:bg-[#37715d] hover:text-[#fff] text-[#37715d] rounded-md group cursor-pointer'
                                                title="Copy URL"
                                                onClick={() => handleCopy(item.Url)}
                                            >
                                                <FaCopy className='text-[#37715d] group-hover:text-[#fff] text-[13px]' />
                                            </div>

                                            {/* Download */}
                                            <div
                                                className='border-[#1976d2] border-[1px] p-1 hover:bg-[#1976d2] hover:text-[#fff] text-[#1976d2] rounded-md group cursor-pointer'
                                                title="Download"
                                                onClick={() => handleDownload(item.Url, item.fileName)}
                                            >
                                                <FaDownload className='text-[#1976d2] group-hover:text-[#fff] text-[13px]' />
                                            </div>

                                            <div
                                                className='border-[#ed5050] border-[1px] p-1 hover:bg-[#ed5050] hover:text-[#fff] text-[#ed5050] rounded-md group cursor-pointer'
                                                title="Delete"
                                                onClick={() => handleDeleteMedia(item.imageid)}
                                            >
                                                <RiDeleteBin5Line className='text-[#ed5050] group-hover:text-[#fff] text-[13px]' />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan="3" className="p-1 text-[11px]">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <p className='text-[11px] text-[#3f7fc8] mt-2' >
                    Showing {filteredData.length > 0 ? 1 : 0} to {filteredData.length} of {filteredData.length} records
                </p>
            </div>
            <Addgroup isOpen={open} onClose={() => setopen(false)} heading='Upload Media' >
                <form onSubmit={handleAddMedia}>
                    <div className='py-2 border-y-[1px] border-[#8b8a8a67] my-2 w-[100%]'>
                        <div className='w-[100%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Channel</label>
                            <select
                                name="channel"
                                id="upload-channel"
                                value={Channel}
                                onChange={(e) => setChannel(e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            >
                                <option value="">-- Select --</option>
                                {Array.isArray(wabaid) && wabaid.length > 0 ? (
                                    wabaid.map((id) => (
                                        <option key={id} value={id}>{id}</option>
                                    ))
                                ) : (
                                    <option value="" disabled>No channels found</option>
                                )}
                            </select>
                        </div>
                        <div className='w-[100%] flex flex-col gap-1 mt-4'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Media File(s)</label>
                            <input
                                type="file"
                                name="media"
                                id="media-upload-field"
                                accept="image/*,video/*,.pdf"
                                multiple
                                onChange={e => {
                                    // convert FileList to Array<File>
                                    setMediaFiles(e.target.files ? Array.from(e.target.files) : []);
                                }}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            />
                        </div>
                        {errorMsg && <div className="text-red-500 text-xs mt-2">{errorMsg}</div>}
                        {successMsg && <div className="text-green-600 text-xs mt-2">{successMsg}</div>}
                    </div>
                    <div className='w-[100%] flex justify-end gap-1'>
                        <button
                            type="submit"
                            disabled={uploading}
                            className={`p-2 bg-[#00816a] rounded-md text-[12px] font-semibold text-[#fff] ${uploading ? 'opacity-50 cursor-not-allowed' : ''}`}>
                            {uploading ? 'Saving...' : 'Save'}
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                setopen(false);
                                setErrorMsg('');
                                setSuccessMsg('');
                                setMediaFiles([]);
                                setChannel('');
                            }}
                            className='p-2 bg-[#d3dde6] rounded-md text-[12px] font-semibold text-[#555555]  '>
                            Close
                        </button>
                    </div>
                </form>
            </Addgroup>
        </>
    )
}

export default MediaLibrary
